import UpdateOnPremObject from './UpdateOnPremObject';

export default class UpdateOnPremObjectRequest {

	onPremObjects!: UpdateOnPremObject[];

	contactId!: string;
	
	justification!: string;

	projectId!: string;
	
	approverId!: string;
	
	creationDate!: Date;

	appEndorserId!: string;

	appEndorserMail!: string;

	constructor(obj: any) {
		Object.assign(this, obj);
	}
}